import React from "react";
import "./TimelineSection.css";

export default function TimelineSection() {
  const stages = [
    {
      title: "Level 1",
      subtitle: "Foundation Internship (Beginner)",
      desc: "Get started with the basics of Generative AI & Agriculture. Build simple hands-on projects."
    },
    {
      title: "Level 2",
      subtitle: "Skill Building Internship (Intermediate)",
      desc: "Enhance your knowledge with intermediate projects. Focus on data handling, models, and farm-related applications."
    },
    {
      title: "Level 3",
      subtitle: "Professional Internship (Advanced)",
      desc: "Work on advanced projects using Computer Vision & GenAI for real agricultural problems."
    },
    {
      title: "Level 4",
      subtitle: "Pre-Placement / Research Internship (Expert)",
      desc: "Industry-level mentoring, research opportunities, and project showcases to prepare you for placements."
    }
  ];

  return (
    <section className="timeline" id="timeline">
      <h2 className="timeline-title">🚀 Internship Journey</h2>
      <div className="timeline-wrapper">
        {stages.map((stage, i) => (
          <div key={i} className="timeline-card">
            <h3>{stage.title}</h3>
            <h4>{stage.subtitle}</h4>
            <p>{stage.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
